import { ApiError } from "next/dist/server/api-utils"

const enableLogs = process.env.NODE_ENV === "development"

export const logger = {
  debug: (...args: any[]) => {
    if (!enableLogs) return
    console.debug(...args)
  },
  info: (...args: any[]) => {
    if (!enableLogs) return
    console.info(...args)
  },
  error: (error: Error | string, ...args: any[]) => {
    if (typeof window !== "undefined" && window?.newrelic?.noticeError) {
      window.newrelic.noticeError(error instanceof Error ? error : new Error(error as string))
    }
    if (!enableLogs) return
    console.error(error, ...args)
  },
  warn: (...args: any[]) => {
    if (!enableLogs) return
    console.warn(...args)
  },
  log: (...args: any[]) => {
    if (!enableLogs) return
    console.log(...args)
  },
  time: (...args: any[]) => {
    if (!enableLogs) return
    console.time(...args)
  },
  timeEnd: (...args: any[]) => {
    if (!enableLogs) return
    console.timeEnd(...args)
  },
}
